<script setup lang="ts">
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/core/components/ui/dialog";
import {Button} from "@/core/components/ui/button";
import {ScanSearch} from "@lucide/vue";
import LiveAuthorizationYes from "@/live/components/LiveAuthorizationYes.vue";

/**
 * LIVE — the dialog that installs the Apodis Live service (AP-7768), opened
 * from the home after a shell update or from the settings, worded as an update
 * of Apodis whether the service is installed or upgraded. The parent runs the
 * installation.
 */
defineProps<{
    activating: boolean;
    failed: boolean;
}>();

const emit = defineEmits<{
    activate: [];
    later: [];
}>();

const open = defineModel<boolean>('open', {required: true});
</script>

<template>
  <Dialog v-model:open="open">
    <DialogContent class="max-w-md">
      <DialogHeader>
        <div class="flex items-center justify-center size-12 rounded-2xl bg-lightPurple-lightest mb-2">
          <ScanSearch class="size-6 text-primary" />
        </div>
        <DialogTitle class="text-primary font-semibold text-lg">
          Mise à jour d'Apodis
        </DialogTitle>
        <DialogDescription class="flex flex-col gap-2 text-gray-dark text-sm">
          <span class="block">
            Une mise à jour est disponible pour assurer le bon fonctionnement d'Apodis.
          </span>
          <span class="block font-semibold text-black">
            Une demande d'autorisation Windows va apparaître. Cliquez sur <LiveAuthorizationYes /> pour poursuivre.
          </span>
        </DialogDescription>
      </DialogHeader>
      <p
        v-if="failed"
        class="text-sm text-red-light"
      >
        La mise à jour n'a pas abouti. Réessayez, ou contactez le support Apodis.
      </p>
      <DialogFooter class="flex flex-row gap-2">
        <Button
          variant="ghost"
          class="rounded-full flex-1"
          :disabled="activating"
          @click="emit('later')"
        >
          Plus tard
        </Button>
        <Button
          class="bg-primary rounded-full flex-1"
          :disabled="activating"
          @click="emit('activate')"
        >
          Mettre à jour
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>
